import { useCallback, useEffect, useState } from 'react';
import { api } from './api';
import type { ChecklistStatus } from './types';

export function useChecklist() {
  const [data, setData] = useState<ChecklistStatus | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const result = await api.onboarding.checklist();
      setData(result);
    } catch {
      // Si falla (tenant sin onboarding, etc.) simplemente no mostramos nada.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { void Promise.resolve().then(() => load()); }, [load]);

  const toggle = useCallback(async (id: string, completed: boolean) => {
    // Optimistic update.
    setData((prev) => {
      if (!prev) return prev;
      const items = prev.items.map((item) => item.id === id ? { ...item, completed } : item);
      return { ...prev, items, completedCount: items.filter((i) => i.completed).length };
    });
    try {
      await api.onboarding.markChecklist(id, completed);
    } catch {
      // Revert on failure.
      load();
    }
  }, [load]);

  const pendingCount = data ? data.totalItems - data.completedCount : 0;
  const allDone = !!data && data.completedCount >= data.totalItems;

  return { data, loading, toggle, pendingCount, allDone, reload: load };
}
